.am{max-width:100%;}